export function isRecStatusAutopilotPending(
	rec_status?: string,
	updated_by?: string,
	autopilot_ind?: boolean,
): boolean {
	if (!rec_status || !updated_by || autopilot_ind === undefined) {
		return false;
	}
	return (
		updated_by === 'AUTOPILOT' && autopilot_ind === true && rec_status === 'P'
	);
}
